import { CLEAR_ERRORS, SET_STATS_LOADING } from "./Types";

// import factory from './actionsFactory';
// eslint-disable-next-line no-undef
const factory = require("./actionsFactory");

export const getDashboardStats = (timeZone) =>
  factory.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_API}/stats/adminDashboard?timeZone=${timeZone}`,
    "GET_DASHBOARD_STATS",
    "STATS_FAIL"
  );

export const getCompanionAnalytics = (locationOrLocations) => {
  const isArray = Array.isArray(locationOrLocations);
  if (isArray) {
    const ids = locationOrLocations.filter(Boolean);
    if (ids.length === 0) {
      return factory.get(
        // eslint-disable-next-line no-undef
        `${process.env.REACT_APP_API}/stats/analytics/guestCompanionReportMulti`,
        "GET_COMPANION_ANALYTICS",
        "COMPANION_ANALYTICS_FAIL"
      );
    }
    if (ids.length === 1) {
      return factory.get(
        // eslint-disable-next-line no-undef
        `${process.env.REACT_APP_API}/stats/analytics/guestCompanionReport?location=${ids[0]}`,
        "GET_COMPANION_ANALYTICS",
        "COMPANION_ANALYTICS_FAIL"
      );
    }
    // multi location
    const locationParam = ids.join(",");
    return factory.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_API}/stats/analytics/guestCompanionReportMulti?locations=${locationParam}`,
      "GET_COMPANION_ANALYTICS",
      "COMPANION_ANALYTICS_FAIL"
    );
  }
  // string or undefined
  if (!locationOrLocations) {
    return { type: "NOOP" };
  }
  return factory.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_API}/stats/analytics/guestCompanionReport?location=${locationOrLocations}`,
    "GET_COMPANION_ANALYTICS",
    "COMPANION_ANALYTICS_FAIL"
  );
};

export const getTopViewedItems = (locationIds) => {
  // Accept array (multiple or single) or undefined (global)
  if (Array.isArray(locationIds)) {
    const ids = locationIds.filter(Boolean);
    if (ids.length === 0) {
      return factory.get(
        `${process.env.REACT_APP_API}/stats/analytics/itemReport`,
        "GET_TOPITEMS",
        "STATS_FAIL"
      );
    }
    if (ids.length === 1) {
      return factory.get(
        `${process.env.REACT_APP_API}/stats/analytics/itemReport?location=${ids[0]}`,
        "GET_TOPITEMS",
        "STATS_FAIL"
      );
    }
    const locationParam = ids.join(",");
    return factory.get(
      `${process.env.REACT_APP_API}/stats/analytics/itemReportMulti?locations=${locationParam}`,
      "GET_TOPITEMS",
      "STATS_FAIL"
    );
  }
  // undefined => global
  return factory.get(
    `${process.env.REACT_APP_API}/stats/analytics/itemReport`,
    "GET_TOPITEMS",
    "STATS_FAIL"
  );
};

export const getPartnerDashboard = (location, timeZone) =>
  factory.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_API}/stats/partnerDashboard/${location}?timeZone=${timeZone}`,
    "GET_DASHBOARD_STATS",
    "STATS_FAIL"
  );

export const getOrders = (location) => {
  const locationParam = Array.isArray(location) ? location.join(",") : location;

  if (!locationParam || locationParam === "") {
    return factory.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_API}/stats/orders/`,
      "GET_DASHBOARD_ORDERS",
      "STATS_FAIL"
    );
  }

  return factory.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_API}/stats/orders?locations=${locationParam}`,
    "GET_DASHBOARD_ORDERS",
    "STATS_FAIL"
  );
};

export const getBookings = (location) => {
  const locationParam = Array.isArray(location) ? location.join(",") : location;

  if (!locationParam || locationParam === "") {
    return factory.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_API}/stats/bookings?sort=createdAt&dir=asc`,
      "GET_DASHBOARD_BOOKINGS",
      "STATS_FAIL"
    );
  }

  return factory.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_API}/stats/bookings?locations=${locationParam}&sort=createdAt&dir=asc`,
    "GET_DASHBOARD_BOOKINGS",
    "STATS_FAIL"
  );
};

export const getConciergeOrders = (id) =>
  factory.get(
    // eslint-disable-next-line no-undef
    `${process.env.REACT_APP_API}/stats/conciergeDashboard?id=${id}`,
    "GET_CONCIERGE_ORDERS",
    "STATS_FAIL"
  );

// Clear Errors
export const clearErrors = () => ({ type: CLEAR_ERRORS });

// Set Loading
export const setLoading = () => ({ type: SET_STATS_LOADING });
